import { jsx as _jsx, jsxs as _jsxs } from 'react/jsx-runtime.js';
import { useEffect } from 'react';
import { Base, Stack } from '@stepstone-genesis/components';
import { useTranslation } from '@stepstone-platform/i18n';
import { ContentHeading } from '../../components/common/ContentHeading/index.js';
import { SocialsWrapper } from '../../components/SocialsWrapper/index.js';
import { hasSocialAuthConsent } from '../../redux/core/consent/consentSlice.js';
import { registrationConsentPositionSelector } from '../../redux/core/siteConfig/siteConfigSlice.js';
import { loginSourceSelector } from '../../redux/core/sourceData/sourceDataSlice.js';
import { RegistrationFooter } from './components/RegistrationFooter/index.js';
import { RegistrationWithEmailForm } from './components/RegistrationWithEmailForm/index.js';
import { RegistrationWithFacebook, RegistrationWithGoogle, } from './components/Socials/index.js';
import { RegistrationAlert } from './components/RegistrationAlert/index.js';
import { FORM_TYPES } from '../../types/paramsConfig.js';
import { useAppDispatch, useAppSelector } from '../../redux/hooks.js';
import { useTranslatedSourceOverrideLabel } from '../../helpers/useTranslatedLabel.js';
import { RegistrationConsent } from './components/RegistrationConsent/index.js';
import { activeWrapperSelector, setActiveView, } from '../../redux/core/wrapperContext/wrapperContextSlice.js';
import { HeaderDescription } from '../../components/common/HeaderDescription/index.js';
import { addDataDogAction, DD_ACTIONS } from '../../logging/datadog.js';
import { useTrack } from '../../tracking/common/hooks/useTrack.js';
export const RegistrationForm = () => {
    const dispatch = useAppDispatch();
    const loginSource = useAppSelector(loginSourceSelector);
    const hasSocialAuthConsentAccepted = useAppSelector(hasSocialAuthConsent);
    const registrationConsentPosition = useAppSelector(registrationConsentPositionSelector);
    const activeWrapper = useAppSelector(activeWrapperSelector);
    const { t } = useTranslation();
    const useSourceOverrideLabel = useTranslatedSourceOverrideLabel(loginSource, t);
    const { trackModalComponentVisible } = useTrack('standard');
    useEffect(() => {
        if (activeWrapper === 'modal' || activeWrapper === 'stepModal') {
            addDataDogAction(DD_ACTIONS.DISPLAY_REGISTRATION_MODAL_STANDARD);
            dispatch(setActiveView(FORM_TYPES.REGISTRATION));
            trackModalComponentVisible();
        }
        else {
            dispatch(setActiveView(FORM_TYPES.REGISTRATION));
        }
    }, []);
    const headerLabel = useSourceOverrideLabel('registration.header');
    const descriptionLabel = useSourceOverrideLabel('registration.body');
    const isHeaderDescriptionVisible = descriptionLabel !== '';
    // For successful registration registrationSlice redirect to candidate/register/success page
    return (_jsxs(Stack, { direction: ['vertical'], spacing: ['spaceS'], "data-testid": "registration-form", children: [_jsx(ContentHeading, { label: headerLabel }), isHeaderDescriptionVisible && (_jsx(HeaderDescription, { label: descriptionLabel })), _jsx(RegistrationAlert, {}), _jsx(RegistrationWithEmailForm, {}), hasSocialAuthConsentAccepted && (_jsx(Base, { pt: 'spaceS', children: _jsxs(SocialsWrapper, { children: [_jsx(RegistrationWithGoogle, {}), _jsx(RegistrationWithFacebook, {})] }) })), registrationConsentPosition === 'bottom' && _jsx(RegistrationConsent, {}), _jsx(RegistrationFooter, {})] }));
};
//# sourceMappingURL=RegistrationForm.js.map